export default () => ({
    iconMenu: {
        transform: 'rotate(90deg)'
    }
});
